import EtchCustomNavigation from './EtchCustomNavigation.component';

export default EtchCustomNavigation;
